import React, {useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import "./index.css"

import { Sidebar } from 'primereact/sidebar';

// Inputs
import { Table, Button } from '../../helpers';
import Search from './Components/Search';
import { Tooltip } from 'primereact/tooltip';

// Common
import CopyToClipboard from '../../common/CopyToClipboard';

// utils
import { getDateString, getProductName, getProductSpecification, getCompanyShortName, numberConversion, isMobile } from '../../utils';

// redux
import { fetchStockMoves, updateSearchParams } from '../../services/redux/reducers/stock/stockMovement';
import { fetchStockMoveTypes, fetchCompanyWarehouses, fetchMaterialBrands } from '../../services/redux/reducers/commonThunk';
import { raiseToast } from '../../services/redux/reducers/toast/toast';
import { getPMCompanyConfig } from '../../setup/pmCompanyConfig';

const StockMovement = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [isFilterShown, setIsFilterShown] = useState(false)

    const isPageLoading = useSelector(state => state.stockMoves.loading)
    const stockMovementData = useSelector(state => state.stockMoves.stockMovementData)
    const paginationParams = useSelector(state => state.stockMoves.paginationParams)
    const searchParams = useSelector(state => state.stockMoves.searchParams)
    const stockMoveTypes = useSelector(state => state.common.stockMoveTypes)
    const companyWarehouses = useSelector(state => state.common.companyWarehouses)
    const materialBrands = useSelector((state) => state.common.materialBrands)

    const userDetails = useSelector(state => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    let { numberLocale } = pmCompanyConfig

    const isMobileDevice = isMobile()

    console.log('stockMovement - data', stockMovementData)
    
    useEffect(()=>{
        dispatch(fetchStockMoveTypes())
        dispatch(fetchCompanyWarehouses())
        dispatch(fetchMaterialBrands())
        getIntialLoadData()
    },[])

    const getIntialLoadData = () => {
        let toDate = new Date()
        toDate.setHours(23, 59, 0, 0)
        toDate = toDate.toISOString()

        let fromDate = new Date()
        fromDate.setDate(fromDate.getDate() - 30)
        fromDate.setHours(0, 0, 0, 0)
        fromDate = fromDate.toISOString()

        const updatedSearchParams = {
            ...searchParams,
            fromDate: fromDate,
            toDate: toDate
        }
        
        dispatch(updateSearchParams(updatedSearchParams))
    }


    const handleOnClickFilter = event => {
        setIsFilterShown(current => !current);
    }

    const handlePageChange = async (e) => {
        let getCompanyParams = { 
            paginator: true, 
            pageNo: e.page + 1, 
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            ...searchParams
        }
        if (getCompanyParams.searchBy !== "all") {
            getCompanyParams[getCompanyParams.searchBy] = getCompanyParams.searchText.trim()
        }
        dispatch(fetchStockMoves(getCompanyParams))
    }

    const getStockMoveTypeBody = (row) => {
        const relatedStockMoveTypes = stockMoveTypes.find((each) => each.stockMoveTypeId === row?.stockMoveTypeId)
        if(relatedStockMoveTypes?.stockMoveType){
            return relatedStockMoveTypes.stockMoveType
        }else{
            return '-'
        }
    }

    const getWareHouseNameBody = (row) => {
        const relatedCompanyWarehouse = companyWarehouses.find((each) => each.warehouseId === row?.warehouseId)
        if(relatedCompanyWarehouse?.warehouseName){
            return relatedCompanyWarehouse.warehouseName
        }else{
            return '-'
        }
    }

    // const getProductBody = (row) => {
    //     let relatedBrand = materialBrands.find(eachBrand => eachBrand.brandId === row?.materialMaster?.brandId)

    //     return (
    //         <div>{relatedBrand?.brandName} - {row?.materialMaster?.productName} - {row?.materialMaster?.variantName}</div>
    //     )
    // }

    // const getProductSpecificationBody = (row) => {
    //     return (
    //         <div>{row?.materialMaster?.productSpecification} {row?.materialMaster?.UOMValue} {row?.materialMaster?.UOM}</div>
    //     )
    // }

    const getProductBody = (row) => {
        let relatedBrand = materialBrands.find(eachBrand => eachBrand.brandId === row?.materialMaster?.brandId)
        let productName = getProductName(relatedBrand?.brandName,row?.materialMaster?.productName, row?.materialMaster?.variantName)
        return (
            <div>{productName}</div>
        )
    }

    const getProductSpecificationBody = (row) => {
        let productSpecification = getProductSpecification(row?.materialMaster?.productSpecification, row?.materialMaster?.UOM,row?.materialMaster?.UOMValue)
        return (
            <div>{productSpecification}</div>
        )
    }

    const getDocNoandMoveTypeBody = (row) => {
        const relatedStockMoveTypes = stockMoveTypes.find((each) => each.stockMoveTypeId === row?.stockMoveTypeId)
        return(
            <div className="text-center">
                <div className='flex flex-row justify-content-center'>
                    <p className='doc-no' style={{ cursor: "pointer" }}>{row?.docNo}</p>
                    <CopyToClipboard text={row?.docNo} />
                </div>
                <div className='stock-move-name'>
                    { `Stock Move Name: ${relatedStockMoveTypes?.stockMoveName ? relatedStockMoveTypes?.stockMoveName : '-'}`}
                </div>
            </div>
        )
    }

    const getBuyerNameAndBuyerPOIdBody = (row) => {
        return(
            <>
                <div className="">
                    <p className='m-0'>{getCompanyShortName(row["buyerPO"][0].companies?.companyName)}</p>
                </div>
            </>
        )
    }

    const getSellerNameAndSellerPOIdBody = (row) => {
        return(
            <>
                <div className="">
                    <p className='m-0'>{getCompanyShortName(row["sellerPO"][0].companies?.companyName)}</p>
                </div>
            </>
        )
    }

    const getMoveDateAndCreatedBy = (row) => {
        let dateString = getDateString(row?.createdAt)
        return (
            <div className="text-center">
                <div className={`custom-tool-tip-${dateString}`}>{dateString}</div>
                <div className="user-name">{row?.users?.firstName + " " + row?.users?.lastName}</div>
                {/*
                <Tooltip target={`.custom-tooltip-${dateString}`} position="top" autoHide>
                    <p className="m-0 mb-1">{row?.remarks}</p>
                </Tooltip>
                */}
            </div>
        )
    }

    const getBuyerDocNoBody = (row) => {
        if(row?.buyerPO?.length > 0){
            if(row["buyerPO"][0]?.docNo){
                return(
                    <div className="text-center">
                        <div className='flex flex-row justify-content-center'>
                            <p className='doc-no' style={{ cursor: "pointer" }}>{row["buyerPO"][0]?.docNo}</p>
                            <CopyToClipboard text={row["buyerPO"][0]?.docNo} />
                        </div>
                    </div>
                )
            }
        }else{
            <div> - </div>
        }
    }

    const getSellerDocNoBody = (row) => {
        if(row?.sellerPO?.length > 0){
            if(row["sellerPO"][0]?.docNo){
                return(
                    <div className="text-center">
                        <div className='flex flex-row justify-content-center'>
                            <p className='doc-no' style={{ cursor: "pointer" }}>{row["sellerPO"][0]?.docNo}</p>
                            <CopyToClipboard text={row["sellerPO"][0]?.docNo} />
                        </div>
                    </div>
                )
            }
        }else{
            <div> - </div>
        }
    }

    const getPrice = (row) => {
        return(
            numberConversion(row.price, numberLocale)
        )
    }

    const tableColumns = [
        {
            header: 'Stock MoveId',
            field: 'stockMoveId',
        },
        {
            header: 'Warehouse Name',
            field: '',
            body: getWareHouseNameBody,
            style: { minWidth:"130px"}
        },
        {
            header: 'Material Id',
            field: 'materialId',
            style: { minWidth:"130px"}
        },
        {
            header: 'Product',
            field: '',
            body: getProductBody,
            style: { minWidth:"200px"}
        },
        {
            header: 'Specifications',
            field: '',
            body: getProductSpecificationBody,
            style: { minWidth:"250px"}
        },
        /*
        {
            header: 'Stock Move Type',
            field: '',
            body: getStockMoveTypeBody
        },
        */
        {
            header: 'Move Qty',
            field: 'moveQty',
            style: { minWidth:"80px"}
        },
        {
            header: 'Price',
            field: 'price',
            body: getPrice,
            style: { minWidth:"90px"}
        },
        {
            header: 'Move Date',
            field: '',
            body: getMoveDateAndCreatedBy,
            style: { minWidth:"150px"}
        },
        {
            header: 'DocNo',
            field: 'docNo',
            body: getDocNoandMoveTypeBody,
            style: { minWidth:"210px"}
        },
        {
            header: 'Buyer Details',
            field: 'buyerPOId',
            body: getBuyerNameAndBuyerPOIdBody,
            style: { minWidth:"200px"}
        },
        {
            header: 'Buyer DocNo',
            field: '',
            body: getBuyerDocNoBody,
            style: { minWidth:"200px"}
        },
        {
            header: 'Seller Details',
            field: '',
            body: getSellerNameAndSellerPOIdBody,
            style: { minWidth:"200px"}
        },
        {
            header: 'Seller DocNo',
            field: '',
            body: getSellerDocNoBody,
            style: { minWidth:"200px"}
        },
    ]

    return(
        <div className='flex flex-column stock-movement-page'>
            <div className="flex flex-column md:flex-row md:justify-content-between">
                <h4 className="mx-2 my-1 md:m-2">STOCK MOVEMENT</h4> 
                <div className="flex gap-2 justify-content-end mb-2">
                    <Button icon="pi pi-filter" className="h-2rem  p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Filter" onClick={handleOnClickFilter} />
                </div>
            </div>

            <div className='flex flex-row'>
                <div className="stock-movement-table" style={{ order: "1", width: isFilterShown  && !isMobileDevice ? "82%" : "100%", maxHeight: "'calc(100%-100px)'" }}>
                    <div className='p-card mb-0' >
                        <div className="flex-grow-1" >
                            <Table 
                                lazy 
                                page={paginationParams.pageNo} 
                                onPageChange={(e)=> handlePageChange(e)} 
                                totalRecords={paginationParams.totalRecords} 
                                tableColumns={tableColumns} 
                                data={stockMovementData} 
                                rows={paginationParams.recordsPerPage} 
                                scrollable={"true"} 
                                scrollHeight="550px"
                                paginator
                                excessPagesFound= {paginationParams.excessPagesFound}
                                loading={isPageLoading}  
                            />
                        </div>
                    </div>
                </div>

                {
                    isFilterShown  && !isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px"}}  className="justify-content-end ">
                        <Search />
                    </div>
                }
                {
                    isFilterShown  && isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                    <Sidebar position='right' visible={isFilterShown} onHide={() => setIsFilterShown(false)}>
                        <Search />
                    </Sidebar>
                    </div>
                }
            </div>

        </div>
    )
}

export default StockMovement